'use client'

import {Input} from "@/app/[locale]/common/components/Input/Input";
import {Button} from "@/app/[locale]/common/components/Button/Button";
import s from './FormAdmin.module.scss';
import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import {ImageCompressor} from "@/app/[locale]/common/components/ImageCompressor/ImageCompressor";
import {TFormAdminProps} from "@/app/[locale]/common/components/FormAdmin/types";
import {ErrorMessage} from "@/app/[locale]/common/components/ErrorMessage/ErrorMessage";
import {getStateFromLocalStorage} from "@/app/[locale]/common/utils/functions/getStateFromLocalStorage/getStateFromLocalStorage";
import {EditorComponent} from "@/app/[locale]/common/components/Editor/Editor";
import {TITLE_VALIDATE} from "../../constants/news";
import {ACCESS_TOKEN_LOCAL_STORAGE_KEY} from "@/app/[locale]/common/constants/app";

export const FormAdmin = ({ type, actionStatus, onSubmit }: TFormAdminProps) => {
    const {
        handleSubmit,
        register,
        setValue,
        formState: { errors },
    } = useForm({
        mode: 'onBlur'
    });
    const buttonLabel = type === 'news' ? 'Create news' : 'Create project';

    const [ isVisible, setIsVisible ] = useState<boolean>(false);
    const [ isOpenAdminPanel, setIsOpenAdminPanel ] = useState(false);
    const handleShowAdminPanel = () => setIsOpenAdminPanel(true);

    useEffect(() => {
        const token = getStateFromLocalStorage(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        setIsVisible(token);
    }, []);

    if (!isVisible) {
        return null;
    }

    if (!isOpenAdminPanel) {
        return (
            <div className={s.admin_button}>
                <Button type={'button'} size={'mobile'} onClick={handleShowAdminPanel}>Show admin panel</Button>
            </div>
        )
    }

    const handleFileChange = (base64: string) => {
        setValue('img', base64, { shouldValidate: true });
    };

    const handleTextChange = (newsDescription: string) => {
        setValue('text', newsDescription, { shouldValidate: true });
    };

    return (
        <form className={s.admin} onSubmit={handleSubmit(onSubmit)}>
            <label>Admin panel</label>
            <Input
                type={'text'}
                label={'title'}
                required={TITLE_VALIDATE.required}
                placeholder={'Title'}
                register={register}
                minLengthSchema={TITLE_VALIDATE.minLength}
            />
            {errors.title && typeof errors.title.message === 'string' && <ErrorMessage message={errors.title.message}/>}

            {
                type === 'projects' &&
                <>
                    <span>example - Task: some text; Solution: some text</span>
                    <Input
                        type={'text'}
                        label={'shortText'}
                        required={TITLE_VALIDATE.required}
                        placeholder={'Project card description'}
                        register={register}
                    />
                </>
            }

            <EditorComponent handleTextChange={handleTextChange}/>
            <input
                type="hidden"
                {...register('text', {
                    validate: value => (value && value.trim().length > 0) || 'Text is required'
                })}
            />
            {errors.text && typeof errors.text.message === 'string' && (<ErrorMessage message={errors.text.message} />)}

            <ImageCompressor
                handleFileChange={handleFileChange}
            />
            <input
                type="hidden"
                {...register('img', {
                    validate: value => value.startsWith("data:image/") || 'Image is required'
                })}
            />
            {errors.img && typeof errors.img.message === 'string' && !errors.img.message.startsWith("data:image/") && (<ErrorMessage message={errors.img.message}/>)}

            <Button
                type={'submit'}
                size={'mobile'}
                disabled={!!errors.title && !!errors.text && actionStatus === 'sending'}
                className={`${actionStatus === 'sending' ? s.admin_disabledButton : ''}`}
            >
                { buttonLabel }
            </Button>
        </form>
    )
};
